import Vue from 'vue'

export default {
    resetStateMutation(state) {
        Vue.set(state, "gridIsOpen", true);
        Vue.set(state, "formIsOpen", false);
    },
    setFormOpen(state) {
        state.formIsOpen = true;
        state.gridIsOpen = false;
    },
    setFormClose(state) {
        state.formIsOpen = false;
        state.gridIsOpen = true;
    },
    selectItems(state, item) {
        state.selectedItems.push(item)
    },
    deleteItem(state, index) {
        delete state.selectedItems[index]
    },
    deleteSelectedItems(state) {
        state.selectedItems = [];
    }
}
